export const States = {
  IS_START: 0,
  IS_NONE: 0,

  IS_ROTATE: 1,
  IS_PAN: 2,
  IS_SPIN: 3,
  IS_DOLLY: 4,

  IS_CAMERA_POSE: 11,

  IS_WINDOW_LEVEL: 1024,
  IS_SLICE: 1025,
};

export default {
  States,
};
